module.exports = __webpack_public_path__ + "static/media/iconfont.f2d60c81.eot";